import React, { useState } from "react";
import MyTimeline from "./MyTimeline";
import Mast from "./Mast";
import About from "./About";
import { uiucTheme } from "../../styles/theme";
import { ThemeProvider } from "@emotion/react";
import { Box } from "@mui/material";
import Navbar from "../../components/Navbar";



const Home: React.FC = () => {
  const [currentTheme, setCurrentTheme] = useState(uiucTheme);
  return (
    <Box sx={{
      background: currentTheme.palette.background.default
    }}>
    <ThemeProvider theme={currentTheme}>
      <Navbar />
      <Mast />
      <About />
      <MyTimeline setCurrentTheme={setCurrentTheme}/>
      </ThemeProvider>
      </Box>
  );
};

export default Home;
